import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[noEmoji], textarea[noEmoji]', // only apply to input and textarea elements
  standalone: true
})
export class NoEmojiDirective {
  private emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;

  constructor(@Optional() private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement | HTMLTextAreaElement;
    if (!input) return;

    const cleanValue = input.value.replace(this.emojiRegex, '');
    if (cleanValue !== input.value) {
      if (this.control?.control) {
        this.control.control.setValue(cleanValue, { emitEvent: false });
      } else {
        input.value = cleanValue;
      }
    }
  }
}
